module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/thurston_promo_custom.26bedac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/thurston_promo_custom.jpg
// module id = zzpC
// module chunks = 1